

var Model = require("../types/Model.js");
var Promise = require("promise");

/**
 * @module Blocking
 * @description This module enables a person to block another person.  The block
 * will also prevent the other person from finding them in a search.  A block can
 * be called either on an existing contact or on a received contact invitation.
 * In either case, the 'blocker' will be asked to confirm the 'block'.  A list
 * will show all blocked persons and buttons that will allow a person to be
 * unblocked.
 */
module.exports = Model({
	name: "blocking",
	init: init,
	listeners: listeners,
	triggers: triggers,
	refresh: refresh,
	_ready: false,
});

function init() {
	this.push([]);
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/blocking/removed": refresh,
		"mqtt:$/blocking/added": refresh,
		"loadchecker:ready": initial_load,
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function triggers() {
	return {
		"block": handle_block,
		"unblock": handle_unblock,
		"unblock:confirm": handle_unblock_confirm
	};
}

/**
 * Takes the _Id of the person to be blocked, and with current user token,
 * calls the api for blocking, then refreshes the list of blocked people.
 *
 * @param  {Object} data Contains the key `who` to Block
 */
function handle_block(data) {
	var who = data.who;
	if (!who) return;

	this.api.people.block // Move the person to the 'blocking' attribute
		.block(who);

	this.dispatch("block", {
		who: who
	});

	this.emit("usermetrics:trigger:track", "block person", {
		who,
	});
}

/**
 * Removes the designates person from the list of blocked contacts.
 * @param  {String} data Blocked person's _id
 * @return {[type]}      [description]
 */
function handle_unblock(data) {
	var unblock = data.who;

	this._to_unblock = unblock;

	this.dispatch("unblocking");

	this.emit("usermetrics:trigger:track", "open unblock person confirmation person", {
		who: unblock,
	});
}

function handle_unblock_confirm() {
	var who = this._to_unblock;
	if (!who) return;

	this.api.people.block
		.unblock(who);

	this.dispatch("unblock", {
		who: who
	});

	this.emit("requests:trigger:unblock:reset");

	this.emit("usermetrics:trigger:track", "unblock person", {
		who,
	});
}

/**
 * Returns an array containing the people currently blocked by the current
 * user.
 * @param  {String} blocker Session token for the current user
 * @return {Array}         Array of _Id's of blocked users.
 */
function refresh() {
	if(!this._ready) return Promise.resolve([]);
	return this.api.people.block.list()
		.then(this.push.bind(this));
}
